class WhySubscribeToggle extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('.why-subscribe__header');
    this.handleClick = this.handleClick.bind(this);
    this.header?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.header?.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    const isExpanded = this.header.getAttribute('aria-expanded') === 'true';
    this.header.setAttribute('aria-expanded', String(!isExpanded));
    this.classList.toggle('why-subscribe--collapsed', isExpanded);
  }
}

customElements.define('why-subscribe-toggle', WhySubscribeToggle);
